import React from 'react'

export default function RetailerDocuments() {
  return (
    <div class="mid-contant">
	<div class="container">		
		<div class="row">
			<div class="col-12">
				<div class="head">
					<h2>ID Details & Upload</h2>
				</div>
			</div>
			
			<div class="col-12">
				<div class="registerbox">
					<div class="row mb-3">
						<div class="col-12 col-lg-7">
							<form >
								<div class="row">
									<div class="col-12 col-lg-7">
										<div class="form-floating">
											<input type="text" class="form-control" id="pan" placeholder="Enter" value=""/>
											<label for="pan">PAN number</label>
										</div>
									</div>
								
									<div class="col-12 col-lg-5">
										<div class="file-upload">	
											<div class="dropzone-wrapper">
												<div class="dropzone-desc">
													<i class="camera"></i>
													<h6>Upload PAN</h6>													
												</div>
												<input type="file" name="fileup" class="dropzone"/>
											</div>											
										</div>
									</div>
									
									<div class="col-12 col-lg-7 mt-4">
										<div class="form-floating">
											<input type="text" class="form-control" id="adhar" placeholder="Enter" value=""/>
											<label for="adhar">Aadhaar number / VID</label>
										</div>
									</div>
									
									<div class="col-12 col-lg-5 mt-4">
										<div class="file-upload">	
											<div class="dropzone-wrapper">
												<div class="dropzone-desc">
													<i class="camera"></i>
													<h6>Upload Aadhaar</h6>													
												</div>
												<input type="file" name="fileup" class="dropzone"/>
											</div>											
										</div>
									</div>
									
									<div class="col-12">
										<div class="formnote">Upload Aadhaar card front and back side photo</div>
									</div>
									
									<div class="col-12 col-lg-5 mt-4">
										<div class="file-upload">	
											<div class="dropzone-wrapper">
												<div class="dropzone-desc">
													<i class="camera"></i>
													<h6>Profile Photo</h6>													
												</div>
												<input type="file" name="fileup" class="dropzone"/>
											</div>											
										</div>
									</div>
									
									<div class="col-12">
										<div class="formnote">upload your full face like it is a passport photo</div>
									</div>									
									
									<div class="col-12">
										<button type="submit" class="btn btn-primary" id="">Continue</button>
									</div>
								</div>
							</form>							
						</div>
						
						<div class="col-12 col-lg-5">
							<div class="rightbanner"><img src={require('../../assests/images/register.png')} alt="Oxigen" class="img-fluid"/></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
  )
}
